import { render, staticRenderFns } from "./VodUploadAlert.vue?vue&type=template&id=9e922270&scoped=true"
import script from "./VodUploadAlert.vue?vue&type=script&lang=js"
export * from "./VodUploadAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e922270",
  null
  
)

export default component.exports